import React from 'react';
import {Box, Grid} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import {TextField, Backdrop} from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import Tooltip from '@mui/material/Tooltip';
// import TreeViewCards from '../components/TreeViewCards.js';
import TreeViewCards from '../components/TreeViewCardsV2.js';
import BreadcrumbsInc from '../components/BreadcrumbsInc.js';
import TreeViewComp from '../components/TreeViewComp.js';
import SearchInputA from '../components/SearchInputA.js';
import DialogStudyContent from '../components/DialogStudyContent.js';
import axios from 'axios';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import {API_URL} from '../utils/EnvVars.js';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy.js";
import LeftDrawer from "../components/LeftDrawer.js";
import ValidityExpiredDialog from "../components/ValidityExpiredDialog.js";
import StudyMaterialInfo from "../components/StudyMaterialInfo.js";
import ContentLimitAlert from "../components/ContentLimitAlert.js";
import NotificationAlerts from "../components/NotificationAlerts.js";
import BottomDrawerStdyMat from "../components/BottomDrawerSm/BottomDrawerStdyMat.js";
import '../styles/bizofficer-a.css';
import { useDispatch, useSelector } from 'react-redux';
///import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setLearningContents, setMockTest } from '../store/data.actions';
import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setLearningContents, setTopicTreeTest, setTopicListTest, setMockTest, setContentLimit } from '../store/data.actions.js';
import TutorialButton from '../components/StudentTutorial/StudentTutorial.js';
import NewTutorialButton from '../components/StudentTutorial/NewStudentTutorial.js';
import Cookies from "js-cookie";
import { setPopup } from '../store/popup.actions.js';
import { PlayCircleFilled } from '@material-ui/icons';
import StudyMaterialHelpVideoButton from '../components/StudyMaterialHelpVideoButton/StudyMaterialHelpVideoButton.js';
import NoCopyWrapper from "../components/NoCopyWrapper/NoCopyWrapper.js";


const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
	paper: {
		fontSize: '12px !important',    
	  }
  }));

  const contentTypesDefault = ['Video','PDF','PPT','Text'];

  export default function Execute() {	
	const dataObj = useSelector(state => state.getData);
	const popup1 = useSelector((state => state?.popup1))
	const ftue = Cookies.get("ftue");
	const dispatch = useDispatch();
	const classes = useStyles();
	///document.write(localStorage.getItem('etlMyCourses'));
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 	
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));

	const [organisationName, setOrganisationName] = React.useState("");
	const [validityExpired, setValidityExpired] = React.useState(false);

	const childRef = React.useRef();  
	const childRefLimit = React.useRef();
	const childRefVED = React.useRef();
	const [smTab, setSmTab] = React.useState(2);
	// const [topicListViewLoading, setTopicListViewLoading] = React.useState(true);
	const [showProgress, setShowProgress] = React.useState(false);
	const [overlay, setOverlay] = React.useState(false);
	const [selectedTopicId, setSelectedTopicId] = React.useState(0);
	const [searchQuery, setSearchQuery] = React.useState(null);
	const [searchFlag, setSearchFlag] = React.useState(null);
	const [material, setMaterial] = React.useState("");
	const [contentTypeList, setContentTypeList] = React.useState([]);
	const [materialsList, setMaterialsList] = React.useState([]);
	const [materialsDisplayList, setMaterialsDisplayList] = React.useState([]);
	const [languageList, setLanguageList] = React.useState([]);
	const [language, setLanguage] = React.useState('');
	const [contentObj, setContentObj] = React.useState({});
	///const [selectedTemplateId, setSelectedTemplateId] = React.useState(0);
	const [cardsTopicObj, setCardsTopicObj] = React.useState({});

	// Help Video Icon State
	const [isHelpVideoOpen, setIsHelpVideoOpen] = React.useState(false);
		
	///const [keywordList, setKeywordList] = React.useState([]);
	const authResult = new URLSearchParams(window.location.search);
	const deviceType = authResult.get('device_type');


  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}

	if(localStorage.getItem('etlStudentObj') === null){
		window.location.href='login';
	}

	React.useEffect(() => {
		filterList(language,material);

	}, [language,material]); 


	function filterList(language, material){
			if(material && material.length>0 && language && language.length>0){
				var result = new Array();
				var length = materialsList.length;
				for(var j = 0; j < length; j++)
				{
					if(material && material.length>0 && language && language.length>0 && material==materialsList[j].contentType && language==materialsList[j].language){
						result.push(materialsList[j]);
					}
				}
				setMaterialsDisplayList(result);

			}else if(language && language.length>0){
				var result = new Array();
				var length = materialsList.length;
				for(var j = 0; j < length; j++)
				{
					if(language && language.length>0 && language==materialsList[j].language){
						result.push(materialsList[j]);
					}
				}
				setMaterialsDisplayList(result);

			}else if(material && material.length>0){
				var result = new Array();
				var length = materialsList.length;
				for(var j = 0; j < length; j++)
				{
					if(material && material.length>0 && material==materialsList[j].contentType){
						result.push(materialsList[j]);
					}
				}
				setMaterialsDisplayList(result);

			}else{
				setMaterialsDisplayList(materialsList);
			}
	  };

	const selectTopic = (obj) => {
		setSearchFlag('Topic');
		setSelectedTopicId(obj.topicId);
		setSearchQuery(obj.topicName);
		if(obj.children && obj.children.length && obj.children.length>0){
			setCardsTopicObj(obj);
		}
		////alert("selectTopic Parent >>> " + obj.topicId + " == " + obj.topicName);
	}

	const searchBoxQuery = (searchFlag,obj) => {
		setSearchFlag(searchFlag);
		setSearchQuery(obj.title);
		setSelectedTopicId(obj.id);
		//alert("Seach Parent >>> " + searchFlag + " == " + searchQuery);
	}

	const selectTopicCard = (obj) => {
		if(obj && obj.topicId>0){
			setSearchFlag('Topic');
			setSearchQuery(obj.topicName);
			setSelectedTopicId(obj.topicId);
			if(obj.children && obj.children.length && obj.children.length>0){
				setCardsTopicObj(obj);
			}	
		}else{
			setCardsTopicObj({});
			if(dataObj && dataObj.learningContents){
				setMaterialsList(dataObj.learningContents);	
				setMaterialsDisplayList(dataObj.learningContents);
				setShowProgress(false); 
			}
		}
	}

	React.useEffect(() => {	
		setContentTypeList(contentTypesDefault);	
		setShowProgress(true);		
		if(searchQuery && searchFlag && searchQuery.length>0 && searchFlag.length>0 && mySelectedCourses!==null && selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId && mySelectedCourses[selectedCourse].studyMaterial===1){
			setMaterial(0);
			setMaterialsList([]);
			setMaterialsDisplayList([]);
			getApiDataFilter(mySelectedCourses[selectedCourse].templateId);

		}else if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].templateId){
			
			let diffDays = 0;
			if(localStorage.getItem('cacheDate')){
				let date1 = new Date(localStorage.getItem('cacheDate'));								
				let date2 = new Date();
				let diffTime = date2.getTime() - date1.getTime();
				diffDays = Math.round(diffTime / (1000 * 3600 * 24));
			}
			///alert("AA: "+diffDays+" == "+localStorage.getItem('templateId')+" == "+mySelectedCourses[selectedCourse].templateId);
			if(diffDays>0 || localStorage.getItem('templateId')!=mySelectedCourses[selectedCourse].templateId){
				getApiDataOnPageLoad(mySelectedCourses[selectedCourse].templateId);
			}else if(dataObj && dataObj.learningContents){
				///alert('asdfasdf')
				setMaterialsList(dataObj.learningContents);	
				setMaterialsDisplayList(dataObj.learningContents);
				setShowProgress(false); 
			}	
			
		}
		
			///getApiDataOnPageLoad(mySelectedCourses[selectedCourse].templateId);
		
	}, [dataObj,searchFlag,searchQuery]); 

	async function getApiDataFilter(templateId){
		///alert("getApiDataFilter");
			setOverlay(true);		
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			///let selectedTopicId_x=2897;
			axios.get(API_URL+'/syllabus?nonRecursive=1&templateId='+templateId+'&searchFlag='+searchFlag+'&topicId='+selectedTopicId+'&searchQuery='+searchQuery, axiosHeader)
			   .then(response => {
				setShowProgress(false); 
				setOverlay(false);
				///document.write("response.data"+JSON.stringify(response.data));
				if(response.data && response.data.responseTxt==='success'){
					if(response.data.obj && response.data.obj?.list && response.data.obj?.list?.length>0){
						setMaterialsList(response.data.obj?.list);	
						setMaterialsDisplayList(response.data.obj?.list);
					}else{
						setMaterialsList([]);
						setMaterialsDisplayList([]);
					}
					if(response.data.obj?.listTwo && response.data.obj?.listTwo?.length>1){
						setLanguageList(response.data.obj?.listTwo);
				   	}else{
						setLanguageList([]);
					}
					if(response.data.obj?.listThree && response.data.obj?.listThree?.length>1){
						setContentTypeList(response.data.obj?.listThree);
				   	}else{
						setContentTypeList([]);
					}	
										
			   	}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.localStorage.clear(); 
					window.location.href='logout';
				
			   	} 
			})
	}

	async function getApiDataOnPageLoad(tempId){
		///alert("getApiDataOnPageLoad");
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		
		setMaterialsList([]);	
		setMaterialsDisplayList([]);

		///tempId=40;
		setShowProgress(true);
		axios.get(API_URL+'/templatecache-section?templateId='+tempId, axiosHeader)
		///axios.get(API_URL+'/studymaterials-topics?templateId='+templateId+"&topicName="+topicName, axiosHeader)
		   .then(response => {
			setShowProgress(false);
			if(response.data && response.data.responseTxt==='success'){

					localStorage.setItem("templateId", tempId);
					localStorage.setItem("cacheDate", new Date());

					if(response.data.smartLearningJson && response.data.smartLearningJson.length>0){
						setMaterialsList(JSON.parse(response.data.smartLearningJson));	
						setMaterialsDisplayList(JSON.parse(response.data.smartLearningJson));
					}

					//*********************************
					if(response.data.topicTree && response.data.topicTree.length>0){
						dispatch(setTopicTree(JSON.parse(response.data.topicTree)));
					}else{
						dispatch(setTopicTree([]));
					}
					if(response.data.topicList && response.data.topicList.length>0){
						dispatch(setTopicList(JSON.parse(response.data.topicList)));
					}else{
						dispatch(setTopicList([]));
					}
					if(response.data.keywordList && response.data.keywordList.length>0){
						dispatch(setKeywordList(JSON.parse(response.data.keywordList)));
					}else{
						dispatch(setKeywordList([]));
					}
					if(response.data.smartLearningJson && response.data.smartLearningJson.length>0){
						dispatch(setLearningContents(JSON.parse(response.data.smartLearningJson)));
					}else{
						dispatch(setLearningContents([]));
					}
					if(response.data.topicTreeLearning && response.data.topicTreeLearning.length>0){
						dispatch(setTopicTreeLearning(JSON.parse(response.data.topicTreeLearning)));
					}else{
						dispatch(setTopicTreeLearning([]));
					}
					if(response.data.topicListLearning && response.data.topicListLearning.length>0){
						dispatch(setTopicListLearning(JSON.parse(response.data.topicListLearning)));
					}else{
						dispatch(setTopicListLearning([]));
					}					
					if(response.data.keywordListLearning && response.data.keywordListLearning.length>0){
						dispatch(setKeywordListLearning(JSON.parse(response.data.keywordListLearning)));
					}else{
						dispatch(setKeywordListLearning([]));
					}
					if(response.data.topicTreeTest && response.data.topicTreeTest.length>0){
						dispatch(setTopicTreeTest(JSON.parse(response.data.topicTreeTest)));
					}else{
						dispatch(setTopicTreeTest([]));
					}
					if(response.data.topicListTest && response.data.topicListTest.length>0){
						dispatch(setTopicListTest(JSON.parse(response.data.topicListTest)));
					}else{
						dispatch(setTopicListTest([]));
					}
					if(response.data.mockTestJson && response.data.mockTestJson.length>0){
						dispatch(setMockTest(JSON.parse(response.data.mockTestJson)));
					}else{
						dispatch(setMockTest([]));
					}

					if(response.data.contentLimit){
						dispatch(setContentLimit(response.data.contentLimit));
					}else{
						dispatch(setContentLimit({}));
					}
			 
			   }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.localStorage.clear(); 
					window.location.href='logout';
			
			   } 
		})
	}



	function exeContent(obj){ 
		if(validityExpired===true){
			childRefVED.current.handleClickOpen();

		}else{

				let openContentFlag = false;
				if(obj && obj.contentType==='PDF' && dataObj.contentLimit && dataObj.contentLimit.pdfMax>0){
					if(localStorage.getItem("contentPDFCounterJson") && localStorage.getItem("contentPDFCounterJson").length>4){
						let countArr = JSON.parse(localStorage.getItem("contentPDFCounterJson"));
						let foundCourse = false;
						for(let i=0; i<countArr.length; i++){
							if(countArr[i].courseId===mySelectedCourses[selectedCourse].courseId){
								if(countArr[i].counter && countArr[i].counter<dataObj.contentLimit.pdfMax && countArr[i].contentIds.indexOf(obj.id)===-1){
									openContentFlag = true;
									if(countArr[i].contentIds && countArr[i].contentIds.indexOf(obj.id)===-1){
										countArr[i].counter = countArr[i].counter+1;
										countArr[i].contentIds = countArr[i].contentIds+','+obj.id;
										localStorage.setItem("contentPDFCounterJson",JSON.stringify(countArr));
									}
								}else if(countArr[i].counter && countArr[i].contentIds.indexOf(obj.id)>-1){
									openContentFlag = true;
								}
								foundCourse = true;
								break;
							}
						}
						if(foundCourse === false){
							countArr.push({counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id});
							localStorage.setItem("contentPDFCounterJson",JSON.stringify(countArr));
						}
					}else{
						localStorage.setItem("contentPDFCounterJson",JSON.stringify([{counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id}]));
						openContentFlag = true;
					}

				}else if(obj && obj.contentType==='PPT' && dataObj.contentLimit && dataObj.contentLimit.pptMax>0){
					///alert(localStorage.getItem("contentPPTCounterJson"));
					if(localStorage.getItem("contentPPTCounterJson") && localStorage.getItem("contentPPTCounterJson").length>4){
						let countArr = JSON.parse(localStorage.getItem("contentPPTCounterJson"));
						let foundCourse = false;
						for(let i=0; i<countArr.length; i++){
							if(countArr[i].courseId===mySelectedCourses[selectedCourse].courseId){
								if(countArr[i].counter && countArr[i].counter<dataObj.contentLimit.pptMax && countArr[i].contentIds.indexOf(obj.id)===-1){
									openContentFlag = true;
									if(countArr[i].contentIds && countArr[i].contentIds.indexOf(obj.id)===-1){
										countArr[i].counter = countArr[i].counter+1;
										countArr[i].contentIds = countArr[i].contentIds+','+obj.id;
										localStorage.setItem("contentPPTCounterJson",JSON.stringify(countArr));
									}
								}else if(countArr[i].counter && countArr[i].contentIds.indexOf(obj.id)>-1){
									openContentFlag = true;
								}
								foundCourse = true;
								break;
							}
						}
						if(foundCourse === false){
							countArr.push({counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id});
							localStorage.setItem("contentPPTCounterJson",JSON.stringify(countArr));
						}
					}else{
						localStorage.setItem("contentPPTCounterJson",JSON.stringify([{counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id}]));
						openContentFlag = true;
					}

				}else if(obj && obj.contentType==='Text' && dataObj.contentLimit && dataObj.contentLimit.textMax>0){
					///alert(localStorage.getItem("contentTextCounterJson"));
					if(localStorage.getItem("contentTextCounterJson") && localStorage.getItem("contentTextCounterJson").length>4){
						let countArr = JSON.parse(localStorage.getItem("contentTextCounterJson"));
						let foundCourse = false;
						for(let i=0; i<countArr.length; i++){
							if(countArr[i].courseId===mySelectedCourses[selectedCourse].courseId){
								if(countArr[i].counter && countArr[i].counter<dataObj.contentLimit.textMax && countArr[i].contentIds.indexOf(obj.id)===-1){
									openContentFlag = true;
									if(countArr[i].contentIds && countArr[i].contentIds.indexOf(obj.id)===-1){
										countArr[i].counter = countArr[i].counter+1;
										countArr[i].contentIds = countArr[i].contentIds+','+obj.id;
										localStorage.setItem("contentTextCounterJson",JSON.stringify(countArr));
									}
								}else if(countArr[i].counter && countArr[i].contentIds.indexOf(obj.id)>-1){
									openContentFlag = true;
								}
								foundCourse = true;
								break;
							}
						}
						if(foundCourse === false){
							countArr.push({counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id});
							localStorage.setItem("contentTextCounterJson",JSON.stringify(countArr));
						}
					}else{
						localStorage.setItem("contentTextCounterJson",JSON.stringify([{counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id}]));
						openContentFlag = true;
					}
				}else if(obj && obj.contentType==='Video' && dataObj.contentLimit && dataObj.contentLimit.videoMax>0){
					///alert(localStorage.getItem("contentVideoCounterJson"));
					if(localStorage.getItem("contentVideoCounterJson") && localStorage.getItem("contentVideoCounterJson").length>4){
						let countArr = JSON.parse(localStorage.getItem("contentVideoCounterJson"));
						let foundCourse = false;
						for(let i=0; i<countArr.length; i++){
							if(countArr[i].courseId===mySelectedCourses[selectedCourse].courseId){
								if(countArr[i].counter && countArr[i].counter<dataObj.contentLimit.videoMax && countArr[i].contentIds.indexOf(obj.id)===-1){
									openContentFlag = true;
									if(countArr[i].contentIds && countArr[i].contentIds.indexOf(obj.id)===-1){
										countArr[i].counter = countArr[i].counter+1;
										countArr[i].contentIds = countArr[i].contentIds+','+obj.id;
										localStorage.setItem("contentVideoCounterJson",JSON.stringify(countArr));
									}
								}else if(countArr[i].counter && countArr[i].contentIds.indexOf(obj.id)>-1){
									openContentFlag = true;
								}
								foundCourse = true;
								break;
							}
						}
						if(foundCourse === false){
							countArr.push({counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id});
							localStorage.setItem("contentVideoCounterJson",JSON.stringify(countArr));
						}
					}else{
						localStorage.setItem("contentVideoCounterJson",JSON.stringify([{counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id}]));
						openContentFlag = true;
					}
				}

			if(openContentFlag === true){
				setContentObj(obj);
				childRef.current.handleClickOpen();	
			}else {
				childRefLimit.current.handleClickOpen();
			}
			
		}

	}

	React.useEffect(() => {
		if(localStorage.getItem('smTab')){
			setSmTab(localStorage.getItem('smTab'));
		}
	}, [localStorage.getItem('smTab')]);

	const handleChangeTabs = (val) => {
		setSmTab(val);
		localStorage.setItem('smTab',val);
	};

	function handleMaterial(typ){
		setMaterial(typ);
	}

	function handleLanguage(lang){
		setLanguage(lang);
	}

	React.useEffect(() => {		
		if(selectedCourse && selectedCourse>=0){
			// Check validity ************************************
			setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
			var d1 = new Date();
			var d2 = new Date(mySelectedCourses[selectedCourse].validTillDate);
			d2.setDate(d2.getDate() + 1);
			if(d1>d2 && mySelectedCourses[selectedCourse].packTypeTitle.indexOf("FREE")===-1){
				setValidityExpired(true);      
			}else{
				setValidityExpired(false);
			}
		}
	}, [selectedCourse]); 

		return (
			<div> 
				<MetaTags>
            		<title>Study Materials</title>
          		</MetaTags>
				
			  	<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				<NotificationAlerts />
				
				{showProgress?<LinearProgress />:null}
				<Box style={{marginLeft:10, marginRight:10}}>		
				<Box mt={1} >

						<Grid container spacing={2} >
							<Grid item md={9} xs={12} style={window.screen.width>480?{backgroundColor:'#f5f5fb', minHeight:'85vh', borderRadius:10}:{backgroundColor:'#f5f5fb', minHeight:'120vh', borderRadius:10}} >
								
								{(dataObj.keywordListLearning && dataObj.keywordListLearning.length>3)?
									<SearchInputA options={dataObj.keywordListLearning} label="Search Keyword" flag="Keyword" toCallParentMethod={searchBoxQuery} />
								:null}

								{(dataObj.topicListLearning && dataObj.topicListLearning.length>3)?
									<Box mt={(dataObj.keywordListLearning && dataObj.keywordListLearning.length>0)?2:0} >
										<SearchInputA options={dataObj.topicListLearning} label="Search Topic" flag="Topic" toCallParentMethod={searchBoxQuery} />
									</Box>
								:null}
								
								<Box mt={1}>
									<Grid container spacing={2}>
										<Grid item md={6} xs={8}>
											<h3 className="heading items_center"><i className='fa fa-book' ></i> Study Material<StudyMaterialInfo />
											<StudyMaterialHelpVideoButton
												state={isHelpVideoOpen} 
												stateHandler={setIsHelpVideoOpen}
												title={"What is MY Study Room and how to use it?"}
												link={"https://www.youtube.com/embed/PBZ_v7gVBXI?si=JKUzsldGRRdmPviL"} />
											</h3>
										</Grid>
										<Grid item md={6} xs={4} >
											<div style={{textAlign:'right'}}>
												<Tooltip title="List View" ><GridViewIcon onClick={()=>{handleChangeTabs(1)}} style={smTab==1?{color:'#000000',cursor:'pointer',border:'1px solid #000',marginRight:2,backgroundColor:'#eae8e8'}:{color:'#CCCCCC',cursor:'pointer',border:'1px solid #e0dede',marginRight:2}} /></Tooltip> 
												<Tooltip title="Tree View" ><AccountTreeIcon onClick={()=>{handleChangeTabs(2)}} style={smTab==2?{color:'#000000',cursor:'pointer',border:'1px solid #000',backgroundColor:'#eae8e8'}:{color:'#CCCCCC',cursor:'pointer',border:'1px solid #e0dede'}} /></Tooltip>
											</div>
										</Grid>
									</Grid>
								</Box>
								<NoCopyWrapper>
									<Box mt={1} >
										{smTab==2?<>
											<p className="headingTwo" style={{marginTop:10}}>Browse Topic & Select</p>
											<TreeViewComp treeViewData={dataObj.topicTreeLearning} toCallParentMethod={selectTopic} />		
										</>	
										:<>
											<BreadcrumbsInc topicTree={dataObj.topicTreeLearning} topicObj={cardsTopicObj} selectTopic={selectTopicCard} />
											<TreeViewCards topicTree={dataObj.topicTreeLearning} topicObj={cardsTopicObj} selectTopic={selectTopicCard} />
										
										</>	
										}
									</Box>
									</NoCopyWrapper>
								
								</Grid>
								{window.screen.width>480?
								<Grid item md={3} xs={12}>
									<NoCopyWrapper>
									<Box style={{marginLeft:7}} >
										<Box>
											<Box>
											<Grid container spacing={2} className="btmbdrgry" >
												<Grid item xs={12} >
													<span style={{fontWeight:'bold'}} >{searchQuery?<span>{searchFlag+': '+searchQuery}</span>:<span>Select topic to begin</span>}</span>
												</Grid>
											</Grid>
											</Box>

											{((contentTypeList && contentTypeList.length>0) || (languageList && languageList.length>0))?
											<Box mt={2}>
												<Grid container spacing={2} >
													{(languageList && languageList.length>0)?
													<Grid xs={6} >
														<TextField
															id="outlined-select-native"
															select
															label="Languages"
															value={language}
															onChange={(event)=>{setLanguage(event.target.value)}}
															SelectProps={{
																native: true,
															}}	
															InputLabelProps={{shrink:true}}
															size='small'	
															classes={{ paper: classes.paper }}
															style={{width:'97%'}}							
														>
															<option value='' >All</option>
															{languageList.map((row) => (
																<option key={row} value={row}>
																{row}
																</option>
															))}
														</TextField>
													</Grid>
													:null}
													<Grid xs={(languageList && languageList.length>0)?6:12} >
														<TextField
															id="outlined-select-native"
															select
															label="Filter"
															value={material}
															onChange={(event)=>{setMaterial(event.target.value)}}
															SelectProps={{
																native: true,
															}}	
															InputLabelProps={{shrink:true}}
															size='small'	
															classes={{ paper: classes.paper }}
															fullWidth
														>
															<option value='' >All</option>
															{(contentTypeList || []).map((row) => (
																<option key={row} value={row}>{row}</option>
															))}
														</TextField>
													</Grid>
												</Grid>
												<TutorialButton/>
											</Box>
											:null}

										</Box>
										<Box component="form" noValidate mt={2} className="selfTestForm animate-zoom" >
											<Grid container spacing={2} className="materialBoxx" >
											{showProgress?<div style={{textAlign:'center',width:'100%'}}><CircularProgress style={{width:20,height:20}} /><br/>Loading...</div>:
											(materialsDisplayList && materialsDisplayList.length>0)?materialsDisplayList.map((myRow,index)=>(				
												<Grid onClick={()=>{exeContent(myRow)}} key={'mtldd'+index} item className="smitem" >
													<p style={{fontSize:'smaller',marginTop:-10,textAlign:'right'}}>&nbsp;{myRow.language}</p>
													<p>
														{myRow.contentType=='Video'?<i className="fa fa-play-circle"></i>:myRow.contentType=='PDF'?<i className="fa fa-file-pdf-o"></i>:myRow.contentType=='PPT'?<i className="fa fa-file-powerpoint-o"></i>:<i className="fa fa-globe"></i>}												
													</p>
													<p className="text-line-2">
														{myRow.contentTitle}
													</p>	
												</Grid>
											)):<div style={{color:'#FF0000',fontSize:14,fontWeight:'bold',textAlign:'center',width:'100%'}}>Study material not found</div>}	
											</Grid>	
										</Box>	
									</Box>
								</NoCopyWrapper>
							</Grid>
							:null}
						</Grid>
				</Box>

				


				</Box>
				</main>
				<NoCopyWrapper>
					<DialogStudyContent topic={searchQuery} contentObj={contentObj} ref={childRef} />
				</NoCopyWrapper>
				<ContentLimitAlert ref={childRefLimit} />
				<ValidityExpiredDialog organisationName={organisationName} ref={childRefVED}  />

				<Backdrop
					sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={overlay}
					// onClick={handleClose}
				>
					<CircularProgress color="inherit" />
				</Backdrop>

			<div className="student_panel_mobile_display">								
				{(searchQuery && window.screen.width<481)?						
					<BottomDrawerStdyMat showProgress={showProgress} searchQuery={searchQuery} languageList={languageList} handleLanguage={handleLanguage} materials={contentTypeList} handleMaterial={handleMaterial} materialsList={materialsList} materialsDisplayList={materialsDisplayList} />						
				:null}	
			</div>	

			{ popup1  ? <NewTutorialButton /> : <></>}

			</div>
		);
 
}